export type LabsCoursesResponse = {
  items: Course[]
  page: number
  pageSize: number
  pagesCount: number
  totalCount: number
}

export type Course = {
  addedAt: string
  addedBy: number
  id: number
  title: string
  type: CourseTypes
  updatedAt: string
  updatedBy: number
}

export enum CourseTypes {
  Default = 0,
  Intership = 1,
  Devclub = 2,
  Refresher = 3,
  Precourse = 4,
  Help2Debug = 5,
  FrontFromScratch = 6,
  Interview = 7,
  OutstaffFront = 30,
  OutstaffBack = 31,
  Public = 300,
}
